var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18.5 19.613"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.706 17.759v-2.763a1.28 1.28 0 0 1 1.274-1.277h2.582a1.28 1.28 0 0 1 1.283 1.277h0v2.769a1.1 1.1 0 0 0 1.075 1.1h1.721a3.1 3.1 0 0 0 3.107-3.1h0V7.914a2.2 2.2 0 0 0-.861-1.715L11 1.475a2.833 2.833 0 0 0-3.53 0L1.609 6.207a2.181 2.181 0 0 0-.861 1.715v7.845a3.1 3.1 0 0 0 3.107 3.1h1.721a1.108 1.108 0 0 0 1.11-1.106h0",
    "data-name": "Path 18603"
  })));
};
export default SvgHome;